var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "fixed inset-0 overflow-hidden z-60" }, [
    _c(
      "div",
      { staticClass: "absolute inset-0 overflow-hidden" },
      [
        _c(
          "transition",
          {
            attrs: {
              "enter-active-class": "ease-in-out duration-500",
              "enter-class": "opacity-0",
              "enter-to-class": "opacity-100",
              "leave-active-class": "ease-in-out duration-500",
              "leave-class": "opacity-100",
              "leave-to-class": "opacity-0",
            },
          },
          [
            _vm.show
              ? _c("div", {
                  staticClass:
                    "absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity",
                })
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _c(
          "section",
          {
            staticClass: "absolute inset-y-0 sm:pl-16 max-w-full right-0 flex",
          },
          [
            _c(
              "transition",
              {
                attrs: {
                  "enter-active-class":
                    "transform transition ease-in-out duration-500 sm:duration-700",
                  "enter-class": "translate-x-full",
                  "enter-to-class": "translate-x-0",
                  "leave-active-class":
                    "transform transition ease-in-out duration-500 sm:duration-700",
                  "leave-class": "translate-x-0",
                  "leave-to-class": "translate-x-full",
                },
              },
              [
                _vm.show
                  ? _c("div", { staticClass: "w-screen max-w-md" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "h-full divide-y divide-gray-200 flex flex-col bg-white shadow-xl",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex-1 h-0 overflow-y-auto flex flex-col",
                            },
                            [
                              _c(
                                "header",
                                {
                                  staticClass:
                                    "space-y-1 py-6 px-4 bg-primary-600 sm:px-6",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex items-center justify-between space-x-3",
                                    },
                                    [
                                      _c(
                                        "h2",
                                        {
                                          staticClass:
                                            "text-lg leading-7 font-medium text-white",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(_vm.heading) +
                                              "\n                                    "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "h-7 flex items-center",
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "text-primary-200 hover:text-white transition ease-in-out duration-150",
                                              attrs: {
                                                "aria-label": "Close panel",
                                              },
                                              on: { click: _vm.hide },
                                            },
                                            [
                                              _c(
                                                "svg",
                                                {
                                                  staticClass: "h-6 w-6",
                                                  attrs: {
                                                    fill: "none",
                                                    viewBox: "0 0 24 24",
                                                    stroke: "currentColor",
                                                  },
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      "stroke-linecap": "round",
                                                      "stroke-linejoin":
                                                        "round",
                                                      "stroke-width": "2",
                                                      d: "M6 18L18 6M6 6l12 12",
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-sm leading-5 text-primary-200",
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(_vm.description) +
                                            "\n                                    "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex-1 flex flex-col justify-between",
                                },
                                [_vm._t("default")],
                                2
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._t("footer", null, { hide: _vm.hide }),
                        ],
                        2
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }